<section class="ptb-2">
    <div class="container">
        <h2 class="backBtn">
            <lucide-icon size="22" color="#333" name="arrow-left" (click)="goBack()"></lucide-icon>
            Event Speakers
        </h2>
        <div class="speakerDetail">
            <div class="speakerList">
                <div class="spekaerItem" 
                    [ngClass]="speakerId == speaker.id ? 'active' : '' " 
                    *ngFor="let speaker of speakerList" 
                    (click)="viewSpeakerDetail(speaker.id)"
                >
                    <div class="photo">
                        <img src="{{speaker.image}}" alt="" />
                    </div>
                    <div class="speakerText">
                        <h3>{{speaker.name}}</h3>
                        <p>{{speaker.department}}</p>
                    </div>
                </div>
            </div>
            <div class="speakerContent">
                <div class="speakerWrapp">
                    <div class="speakerImg">
                        <img src="{{singleSpeaker?.image}}" alt="" />
                    </div>
                    <div class="speakerCaption">
                        <h3>{{singleSpeaker?.name}}</h3>
                        <p>{{singleSpeaker?.department}}</p>
                    </div>
                </div>
                <p>{{singleSpeaker?.description}}</p>
                <div class="downloadItem">
                    <h4>Download Files</h4>
                    <div class="single-file flex justify-content-between">
                        <div class="fileInfo">
                          <lucide-icon name="FileText" class="icon" color="#666" [size]="16"></lucide-icon>
                          <div class="fileDesc">
                            <h4 class="file-name" matTooltip="Test" matTooltipPosition="left">
                              Capex Item File
                            </h4>
                            <span class="name">1.2Mb</span>
                          </div>
                        </div>
                        <span class="delete-file">
                          <lucide-icon name="download" class="my-icon" [size]="18" color="#202020"></lucide-icon>
                        </span>
                      </div>
                </div>
            </div>
        </div>
    </div>
</section>